import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OptionItem } from '../../../shared/types/api-responses.type';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterCategoryFormValidations } from './category-form-validations';
import { firstValueFrom } from 'rxjs';
import { showNotification } from '../../../shared/helpers/helpers';
import { CategoriesService } from '../../../services/categories/categories.service';
import { CategoryData } from '../categories.interface';
import { showAlert } from '../../../shared/helpers/alert';

@Component({
  selector: 'app-categories-form',
  templateUrl: './categories-form.component.html',
  styleUrls: ['./categories-form.component.css'],
})
export class CategoriesFormComponent implements OnInit {
  loading: boolean = false;
  form!: FormGroup;
  readonly id: string;
  catData!: CategoryData;
  activeStatus: OptionItem[] = [];
  readonly masterCategoryFormValidations = MasterCategoryFormValidations;

  constructor(
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly categoryService: CategoriesService,
    private readonly router: Router
  ) {
    this.id = this.route.snapshot.paramMap.get('id') ?? '';
  }

  async ngOnInit(): Promise<void> {
    this.activeStatus = [
      {
        label: 'Active',
        value: '1',
      },
      {
        label: 'Inactive',
        value: '0',
      },
    ];
    this.initForm();
    await this.loadInitialData();
  }

  private initForm(): void {
    this.form = this.fb.group({
      name: ['', Validators.required],
      code: ['', Validators.required],
      active: [null, Validators.required],
    });

    // this.form.valueChanges.subscribe(console.log);
  }

  private async loadInitialData(): Promise<void> {
    this.loading = true;
    try {
      if (this.id) {
        await this.getCategoryData();
      }
    } catch (error) {
      console.error('Error loading initial data:', error);
      this.showNotification('error', 'Error', 'Failed to load some initial data.');
    } finally {
      this.loading = false;
    }
  }

  private async getCategoryData(): Promise<void> {
    try {
      const { data } = await firstValueFrom(this.categoryService.getCategoryById(this.id));
      this.catData = data;
      this.patchCategoryData(data);
    } catch (error) {
      showNotification('error', 'Failed to fetch user', JSON.stringify(error));
    }
  }

  private patchCategoryData(cat: CategoryData): void {
    this.form.patchValue({
      name: cat.name,
      code: cat.code,
      active: cat.active,
    });
  }

  async createCategory(): Promise<void> {
    this.loading = true;
    try {
      // console.log(JSON.stringify(this.form.value));
      // return ;
      this.loading = true;
      const resp = await firstValueFrom(this.categoryService.createCategory(this.form.value));
      this.loading = false;
      if (resp.code === 0) {
        showNotification('success', 'Success', 'Category created successfully');
        await this.router.navigate(['/categories/list']);
      } else {
        showNotification('error', 'Error', 'Failed to create category');
        this.loading = false;
      }
    } catch (error) {
      showNotification('error', 'Error', JSON.stringify(error));
    } finally {
      this.loading = false;
    }
  }

  async updateCategory(): Promise<void> {
    this.loading = true;
    try {
      // console.log(this.form.value);
      const resp = await firstValueFrom(this.categoryService.updateCategory(this.id, this.form.value));
      if (resp.code === 0) {
        showNotification('success', 'Success', 'User update successfully');
        await this.router.navigate(['/categories/list']);
      } else {
        showNotification('error', 'Error', 'Failed to update user');
      }
    } catch (error: any) {
      console.log('Error:', error);
      showNotification('error', 'Error', error);
    } finally {
      this.loading = false;
    }
  }

  async saveData(): Promise<void> {
    console.log('form value is : ', this.form.value);
    if (this.id) {
      await this.updateCategory();
      return;
    }
    await this.createCategory();
    return;
  }

  private showNotification(type: 'success' | 'error', title: string, text = 'Success'): void {
    showAlert({ type, title, text }).then();
  }
}
